







































import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component, Prop } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { actionsEvent } from '@/setup';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import Confirmation from '@/components/Confirmation.vue';
import HandleErrors from '@/config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';
const { AgGridVue } = require('ag-grid-vue');

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { LoadingService } from '@/services/loadingService';
import { fetchRecepcion } from '../fetchRecepcion';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import Dispositivo from '../Dispositivos/Dispositivo.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import ModalEdicion from './ModalEdicion.vue';

@Component({
  components: {
    MantenedorGrid,
    MantenedorGridSinCodigo,
    ModalEdicion,
    AgGridVue,
  },
})
export default class DispositivosSeriadosEdicion extends ComponenteBase {
  @Prop({ default: false }) esEdicion: boolean;
  @Prop({ required: true }) codigo: number;
  @Prop({ default: false }) mostrarSerie: boolean;
  filtro: string = '';
  modalEdicion: boolean = false;
  selected: any;
  ordesList: any[] = [];

  funcionalidad: Funcionalidades = Funcionalidades.TablasRecepcionEquipos;
  usuario = JSON.parse(localStorage.getItem('user')).id;
  modal: any;
  mounted() {
    this.modal = this.$refs.modal;
  }

  async getMovimientosSelected() {
    let self = this;
    this.loadingService.showLoading();
    return fetchRecepcion(
      { codigo: this.codigo },
      'conectaMoviDispositivos/get_seriados_selected'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          //self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return false;
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error con los dispositivos seriados', {
          timeout: 3000,
        });
        return false;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async actualizarDatos(data: boolean) {
    this.ordesList = await this.getMovimientosSelected();
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
    this.modalEdicion = false;
  }

  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getMovimientosSelected();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }
  onSelectionChanged() {}
  accionesTotales: PermisoAccion[] = [];

  // Globales
  search: string = '';
  loadingService = new LoadingService();
  handleErrors: HandleErrors = new HandleErrors();

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  agGridUtil: AgGridUtil;
  serverSide: any;

  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  dateFormatter(params: any) {
    return moment(params.value).format('MM/DD/YYYY');
  }
  constructor() {
    super();
  }

  readonly gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 30,
    rowModelType: 'normal',
    singleClickEdit: true,
    localeText: {
      noRowsToShow: 'No se han seleccionado dispositivos seriados',
    },
    columnDefs: [
      {
        headerName: 'Serie Número',
        field: 'serienumero',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 200,
        width: 200,
        lockPinned: true,
      },
      {
        headerName: 'Tipo Equipo',
        field: 'tipoeqname',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 400,
        minWidth: 400,
        lockPinned: true,
      },
      {
        headerName: 'Rack',
        field: 'moviserierack',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 400,
        minWidth: 400,
        lockPinned: true,
      },
      {
        headerName: 'Bloque',
        field: 'moviseriebloque',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        width: 340,
        minWidth: 340,
        lockPinned: true,
      },
      makeAccionesColumnDef(this.funcionalidad),
    ],
    //rowModelType: 'serverSide',
    serverSideDatasource: this.serverSide,
    rowSelection: 'multiple',
    columnTypes: {
      fecha: {
        sortable: true,
        resizable: true,
        filter: false,
      },
    },
    onGridReady: this.handleGridReady,
    onModelUpdated: this.onModelUpdated,
    onSelectionChanged: this.onSelectionChanged,
    processCellForClipboard: ({ value }) => {
      return value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value;
    },
    onGridSizeChanged: event => {
      event.api.sizeColumnsToFit();
    },
  };

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  created() {
    this.initialize();
  }

  editedItem: any;

  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (this.funcionalidad === Funcionalidades.TablasRecepcionEquipos) {
        if (data.action === Accion.Editar) {
          this.editedItem = null;
          // Editar - Ver Detalle
          //this.modalEsEdicion = data.action == Accion.Editar;
          //this.editedIndex = data.id;

          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            //this.showModalEdit = true;
            this.editedItem = data.cellRendererParams.data.serienumero;
            this.modal.cargarInfo(this.editedItem);
            this.modalEdicion = true;
          }
        }
      }
    });
  }
}
